import type { ReceiptId, StaffId, StoreId } from "@KassaroAB/shared/types/ids";
import type { RestReceipt } from "@KassaroAB/shared/types/receipt";
import type { ReceiptType } from "@KassaroAB/shared/types/enums/receiptType";
import { api } from "../utils/api";

export interface ReceiptFilters {
  type?: ReceiptType;
  staffId?: StaffId;
  startDate?: string;
  endDate?: string;
}

export const getReceiptsApi = async (
  storeId: StoreId,
  cursor: ReceiptId | null,
  filters?: ReceiptFilters,
): Promise<RestReceipt[]> => {
  const params = new URLSearchParams();
  if (filters?.type) {
    params.append("type", filters.type);
  }
  if (filters?.staffId) {
    params.append("staffId", filters.staffId);
  }
  if (filters?.startDate) {
    params.append("startDate", filters.startDate);
  }
  if (filters?.endDate) {
    params.append("endDate", filters.endDate);
  }
  if (cursor) {
    params.append("cursor", cursor);
  }
  const queryString = params.toString();
  return api.get(`stores/${storeId}/receipts${queryString ? `?${queryString}` : ""}`);
};

export const getReceiptApi = async (
  storeId: StoreId,
  receiptId: ReceiptId,
): Promise<RestReceipt> => {
  return api.get(`stores/${storeId}/receipts/${receiptId}`);
};

export const getReceiptByNumberApi = async (
  storeId: StoreId,
  receiptNumber: number,
): Promise<RestReceipt> => {
  return api.get(`stores/${storeId}/receipts/number/${receiptNumber}`);
};
